/* clients are stored [{relId: {id: ..}}]
 */
import Vue from 'vue'

export default {
  state: {
    objects: {},
    detail: {},
    indices: {
      'clientId': {}
    }
  },
  mutations: {
    addClientDetail (state, relationship) {
      Vue.set(state.detail, relationship.id.toString(), relationship)
    },
    addClient (state, client) {
      if (client && client.id) {
        Vue.set(state.objects, client.id.toString(), client)
      }
    },
    addManyClients (state, clients) {
      if (clients) {
        clients.forEach((client) => {
          if (client && client.id) {
            Vue.set(state.objects, client.id.toString(), client)
          }
        })
        window.localStorage.setItem('clients', JSON.stringify(state))
      }
    },
    deleteClient (state, client) {
      if (client && client.id) {
        Vue.delete(state.objects, client.id.toString())
      }
    },
    clearClients (state) {
      state.objects = {}
    },
    setState (state, newState) {
      state = newState
    }
  },
  actions: {
    loadClientsFromOffline ({ state, commit, rootState }) {
      let clientList = window.localStorage.getItem('clients')
      if (clientList) {
        commit('setState', JSON.parse(clientList))
      }
    }
  },
  getters: {
    clients (state) {
      // return state.objects
      let copy = Object.values(state.objects)
      // let clients = state.objects
      // clients['lookup'] = state.indices.relationshipId
      // return clients
      return copy.sort((a, b) => {
        if (a.client.first_name < b.client.first_name) { return -1 }
        if (a.client.first_name > b.client.first_name) { return 1 }
        return 0
      })
    },
    getClientByUserId: (state, getters) => (id) => {
    },
    getClientByRelationshipId: (state, getters) => (id) => {
      try {
        return state.objects[id]
      } catch (err) {
        console.log(err)
        return null
      }
    },
    getClientDetailByRelationshipId: (state, getters) => (id) => {
      try {
        return state.detail[id]
      } catch (err) {
        console.log(err)
        return null
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/clients.js